export function setLayout(layout: string) {
  return {
    type: "SET_LAYOUT",
    data: layout,
  };
}
